import axios from "axios";

const normalizeBaseUrl = (value, fallback) => {
  let v = String(value || fallback || "").trim().replace(/\/+$/, "");
  if (!v) return fallback;
  if (!/^https?:\/\//i.test(v)) v = `https://${v}`;
  return v;
};

const BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_API_URL ||
    (typeof window !== "undefined" && window.__API_URL__),
  "http://localhost:3001"
);

export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

let storedToken = null;
export const setAuthToken = (token) => {
  storedToken = token || null;
};

api.interceptors.request.use((config) => {
  if (storedToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${storedToken}`;
  }
  return config;
});

export default api;
